import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

/**
 * Hands files dropped on the editor to a host that owns uploading.
 *
 * With `useHostFilePicker` the editor has no uploader of its own, so it cannot take a drop
 * itself. A host whose iframe is cross-origin cannot see the drop either, so without this a
 * file dropped on the canvas is lost. The files go out as `File` objects, which survive
 * `postMessage`'s structured clone but not the Flutter bridge's JSON, so useSystemDrag
 * installs this only for a web host that opts in through `hostSettings.forwardFileDropsToHost`.
 *
 * Returns the function that removes the listeners.
 */
function listenForHostFileDrops(): () => void {
  function onDragOver(e: DragEvent) {
    // Without this the browser opens the file in the iframe instead of firing drop.
    e.preventDefault();
  }

  function onDrop(e: DragEvent) {
    e.preventDefault();
    const files = Array.from(e.dataTransfer?.files ?? []);
    if (files.length) {
      sendPostMessage('uploader.hostFilesDropped', { files });
    }
  }

  window.addEventListener('dragover', onDragOver);
  window.addEventListener('drop', onDrop);

  return () => {
    window.removeEventListener('dragover', onDragOver);
    window.removeEventListener('drop', onDrop);
  };
}

export default listenForHostFileDrops;
